<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'export-form',
    props: {
      data: {
        type: Array,
        required: true
      },
      fields: {
        type: Array,
        required: true
      },
      interval: {
        type: String,
        required: true
      },
      period: {
        type: String,
        required: true
      }
    },
    data: () => ({
      isLoading: false,
      fieldsSelected: [],
      fileName: 'report',
      fileType: 'xlsx',
      itemsSelected: [],
      selectedTree: [],
      sheetLayout: 'trailer'
    }),
    computed: {
      exportData() {
        //only tree view using, may be obsolete
        const data = {}
        for (const d of this.data) {
          const { name, usage } = d
          if (!data[name]) {
            data[name] = {
              name,
              usage: []
            }
          }
          const usageArr = Object.entries(usage).map(([time, values]) => {
            const valuesFixed = {}
            for (const v in values) {
              const k = this?.fieldsByKey?.[v] || v
              valuesFixed[k] = values[v]
            }
            return { time, ...valuesFixed }
          })
          data[name].usage = [...data[name].usage, ...usageArr]
        }
        return data
      },
      fieldsByKey() {
        if (!this?.fields?.length) return {}
        const fields = {}
        for (const v of this.fields) {
          fields[v.value] = v.text
        }
        return fields
      },
      treeOptions() {
        return Object.values(this.exportData).map(d => ({
          ...d,
          id: d.name,
          usage: d?.usage.map(u => ({
            ...u,
            name: u.time,
            id: `${d.name}${u.time}`
          }))
        }))
      }
    },
    methods: {
      async onExport() {
        // const URL = 'http://localhost:8000/report'
        const URL = process.env.VUE_APP_API_URL + 'report'
        // let fileName = `${this.fileName}.${this.fileType}`
        let fileName = `${this.fileName}`
        let body = { options: { fileType: this.fileType, fileName }, data: {} }

        const optionsBySheet = {}
        if (this.interval === 'day') {
          const optionsByDate = {}

          //interval day, layout date
          if (this.sheetLayout === 'date') {
            for (const data of this.data) {
              const trailerName = data.name
              Object.entries(data?.usage)?.forEach(([date, usage]) => {
                const id = `${trailerName}${date}`
                if (this.selectedTree.includes(id)) {
                  if (!optionsByDate?.[date]?.length) {
                    optionsByDate[date] = []
                  }
                  delete usage.time
                  optionsByDate[date] = [...optionsByDate[date], { trailer: trailerName, ...usage }]
                  // optionsByDate[date] = [...optionsByDate[date], { trailer: trailerName, ...usage }]
                }
              })
            }
            body.data = optionsByDate
          }

          //interval day, layout trailer
          if (this.sheetLayout === 'trailer') {
            for (const data of this.data) {
              // console.log(data)
              const sheetName = data.name
              let sheetData = []
              let workingDate = ''
              Object.entries(data.usage).forEach(([date, usage]) => {
                workingDate = date
                const id = `${sheetName}${date}`
                // console.log(id)
                if (this.selectedTree.includes(id)) {
                  // console.log('tree includes id')
                  delete usage.time
                  sheetData = [...sheetData, { date, ...usage }]
                  // console.log(sheetData)
                }
              })
              if (sheetData?.length) {
                if (!optionsBySheet[sheetName]) {
                  optionsBySheet[sheetName] = []
                }
                // optionsBySheet[sheetName] = [...optionsBySheet[sheetName], {  date: workingDate }]
                optionsBySheet[sheetName] = [...optionsBySheet[sheetName], ...sheetData]
                optionsBySheet[sheetName] = [...optionsBySheet[sheetName], {}]
              }
            }
            body.data = optionsBySheet
          }
        }

        //interval minute
        if (this.interval === 'minute') {
          const optionsBySheet = {}
          //interval minute, layout date
          if (this.sheetLayout === 'date') {
            const optionsByDate = {}
            for (const data of this.data) {
              const trailerName = data.name

              Object.entries(data.usage).forEach(([date, minutes]) => {
                const id = `${trailerName}${date}`
                // console.log(id)
                if (this.selectedTree.includes(id)) {
                  if (!optionsBySheet[date]) {
                    optionsBySheet[date] = []
                  }
                  let sheetData = Object.entries(minutes)?.map(([time, values]) => {
                    return { time, ...values }
                  })

                  sheetData = [{ time: trailerName }, ...sheetData, {}]
                  optionsBySheet[date] = [...optionsBySheet[date], ...sheetData]
                }
              })
            }
            body.data = optionsByDate
          }

          //interval minute, layout trailer
          if (this.sheetLayout === 'trailer') {
            for (const data of this.data) {
              // console.log(data)
              const sheetName = data.name
              Object.entries(data.usage).forEach(([date, minutes]) => {
                let sheetData = []
                Object.entries(minutes).forEach(([time, values]) => {
                  const id = `${sheetName}${date}`
                  // console.log(id)
                  if (this.selectedTree.includes(id)) {
                    sheetData = [...sheetData, { time, ...values }]
                  }
                })
                if (sheetData?.length) {
                  if (!optionsBySheet[sheetName]) {
                    optionsBySheet[sheetName] = []
                  }
                  optionsBySheet[sheetName] = [...optionsBySheet[sheetName], { time: date }]
                  optionsBySheet[sheetName] = [...optionsBySheet[sheetName], ...sheetData]
                  optionsBySheet[sheetName] = [...optionsBySheet[sheetName], {}]
                }
              })
            }
          }
          body.data = optionsBySheet
        }

        const res = await fetch(URL, {
          headers: {
            'Content-Type': 'application/json'
          },
          method: 'POST',
          credentials: 'include',
          withCredentials: true,
          body: JSON.stringify(body)
        })
        const contentType = res?.headers?.get('content-type') || ''
        // console.log(contentType)
        //TODO:
        //maybe test here for filetype blob instead
        //then if json, report error, else return generic error
        if (contentType?.includes('json')) {
          const json = await res.json()
          if (json?.status === 'error') {
            this.$store.dispatch('triggerSnackbar', {
              message: json.message,
              color: json.status
            })
            return
          }
        }
        const blob = await res.blob()
        if (blob != null) {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = fileName
          document.body.appendChild(a)
          a.click()
          a.remove()
          this.settingsSave()
        }
      },
      settingsLoad() {
        const validLayoutSettings = ['date', 'trailer']
        const layoutSetting = localStorage.getItem('export-layout')
        if (validLayoutSettings.includes(layoutSetting)) {
          this.sheetLayout = layoutSetting
        }
        const validFiletypeSettings = ['csv', 'xlsx']
        const filetypeSetting = localStorage.getItem('export-filetype')
        if (validFiletypeSettings.includes(filetypeSetting)) {
          this.fileType = filetypeSetting
        }
        const filename = localStorage.getItem('export-filename')
        if (filename) {
          this.fileName = filename
        }
      },
      settingsSave() {
        localStorage.setItem('export-layout', this.sheetLayout)
        localStorage.setItem('export-filetype', this.fileType)
        localStorage.setItem('export-filename', this.fileName)
      }
    },
    mounted() {
      this.settingsLoad()
      let ops = []
      Object.values(this.treeOptions).forEach(d => {
        ops = [...ops, ...d.usage.map(u => u.id)]
      })
      this.selectedTree = [...ops]
      // this.$nextTick(() => (this.selectedTree = [...ops]))
      // this.$nextTick(() => (this.selectedTree = [...this.treeOptions]))
    }
  }
</script>

<template>
  <v-card class="default-dialog">
    <v-icon color="primary" @click="$emit('close')" class="close-btn">mdi-close</v-icon>
    <v-card-title class="primary--text text-h4 d-flex flex-column align-start justify-start">
      EXPORT PROPERTIES

      <p class="primary--text text-body-1 text-left mb-0">
        <!-- (Options disabled demo mode) -->
      </p>
    </v-card-title>

    <v-card-text>
      <v-row>
        <v-col cols="12" class="text-left">
          <p class="primary--text font-weight-bold text-body-1 mb-0">Data</p>
          <v-sheet outlined style="height: 160px; overflow-y: auto">
            <v-treeview v-model="selectedTree" selectable :items="treeOptions" item-children="usage" item-key="id"></v-treeview>
          </v-sheet>
        </v-col>
        <v-col cols="12" class="text-left">
          <p class="primary--text font-weight-bold text-body-1 mb-0">Sheets</p>
          <v-radio-group v-model="sheetLayout" row>
            <v-radio color="accent" label="By Date" value="date"></v-radio>
            <v-radio color="accent" label="By Trailer" value="trailer"></v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" class="text-left">
          <p class="primary--text font-weight-bold text-body-1 mb-0">File</p>
          <!-- <v-radio-group v-model="fileType" row>
            <v-radio color="accent" label="CSV" value="csv"></v-radio>
            <v-radio color="accent" label="XLSX" value="xlsx"></v-radio>
          </v-radio-group> -->
          <v-text-field v-model="fileName" outlined :suffix="`.${fileType}`"></v-text-field>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="pa-8 pb-6">
      <v-btn block color="primary" :disabled="!selectedTree?.length" :loading="isLoading" @click="onExport"
        ><v-icon left>mdi-table-arrow-down</v-icon><span class="font-weight-bold">EXPORT USAGE</span></v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<style scoped></style>
